<template lang="pug">
  card-power-ball(style="height:100%;")
    v-row(justify="center")
      v-col(cols=12 align="center").pt-0
        h3.white--text.font-weight-power-ball {{ $t('lasted-result') }}
    v-row(no-gutters justify="center" align="center" )
      v-col(cols="auto" )
        winnumber(
          :win-number-array="winNumberArray"
        ) 
      v-col(cols="auto" align="center" v-if="winNumberArray.length !== 0").pl-3
        h6.white--text.font-weight-power-ball Power Play
        h3.white--text x {{ powerPlay }}
</template>
<script>
import CardPowerBall from './CardBasePowerBall.vue'
import Winnumber from './Winnumber'
export default {
  components: {
    CardPowerBall,
    Winnumber
  },
  props: {
    winNumberArray: {
      type: Array,
      default: ()=> []
    },
    powerPlay: {
      type: Number,
      default: null
    }
  } 
}
</script>